export default {"src":"/_next/static/media/avatar.f2029526.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};